import apiUtil from 'js/lib/api';

type RecoveryEmailResponse =
  | {}
  | {
      recoveryEmail: {
        emailAddress: string;
        userId: string;
        isVerified: boolean;
      };
    };

export function getUserRecoveryEmail({ userId }: { userId: number }) {
  const api = apiUtil('/api/grpc/useremails/v1/RecoveryEmailsAPI', {
    type: 'rest',
  });
  return api.post<RecoveryEmailResponse>('GetRecoveryEmail', { data: { userId } });
}

export function insertRecoveryEmail({ emailAddress, userId }: { emailAddress: string; userId: number }) {
  const api = apiUtil('/api/grpc/useremails/v1/RecoveryEmailsAPI', {
    type: 'rest',
  });
  return api.post<RecoveryEmailResponse>('InsertRecoveryEmail', { data: { emailAddress, userId } });
}

export function sendVerificationEmail({ emailAddress, userId }: { emailAddress: string; userId: number }) {
  const api = apiUtil('/api/grpc/useremails/v1/UserEmailsAPI', {
    type: 'rest',
  });
  return api.post('SendRecoveryVerificationEmail', { data: { emailAddress, userId } });
}
